export default __webpack_public_path__ + "static/intro_reversed-poster-d4de407d5d2f621ac9159b9d2cb2a634.avif";